import { render, staticRenderFns } from "./ReplacementMain.vue?vue&type=template&id=48d1cb7f&scoped=true&"
import script from "./ReplacementMain.vue?vue&type=script&lang=js&"
export * from "./ReplacementMain.vue?vue&type=script&lang=js&"
import style0 from "./ReplacementMain.vue?vue&type=style&index=0&id=48d1cb7f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d1cb7f",
  null
  
)

export default component.exports